import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledPatientReferenceIdentifier = styled.div`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.textBody};
`;

StyledPatientReferenceIdentifier.displayName = 'StyledPatientReferenceIdentifier';
